import {useEffect, useRef} from 'react';

import {useEventStream} from './useEventStream';

import type {RealtimeEventType} from '@sollapay/enums';
import type {RealtimeEvent} from '@sollapay/types';

export function useRealtimeEvent<T extends RealtimeEventType>(
  eventType: T,
  handler: (event: Extract<RealtimeEvent, {type: T}>) => void
): void {
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  });

  useEventStream(event => {
    if (event.type !== eventType) return;
    handlerRef.current(event as Extract<RealtimeEvent, {type: T}>);
  });
}
